// extracted by mini-css-extract-plugin
export default {"productCarousel":"b9-z","itemsContainer":"c9-z"};